// extracted by mini-css-extract-plugin
export default {"container":"about-mobile_container__-I0N8","children":"about-mobile_children__+A84S","header":"about-mobile_header__IPhu0"};